import { getTablePresets } from '../services';
export const fetchPresets = () => getTablePresets().then(response => formatResponse(response?.data));
const formatResponse = (response) => ({
    presets: response?.presets,
    errors: response?.errors,
    success: response?.success,
    warnings: response?.warnings,
});
